import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Box, FormField, Link, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiInformation } from '@mdi/js';
import Icon from '@mdi/react';
import Confirm from '../../../../../components/extras/Confirm';
import Favorites from '../../../../../components/extras/Favorites';
import Licences from '../../../../../components/Licences';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemUser } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';

export const MembersEDVLicencesPage = () => {
    const [user, setUser] = useState<ItemUser>();
    const [update, setUpdate] = useState(false);
    const { data, menu, idUser } = useGlobalState();
    useGlobalState();
    const { navigate } = useRouter();


    useEffect(() => {
        handleGetUser()
    }, [idUser]);

    const handleGetUser = async () => {
        if (idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/profile/get',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({
                    }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(data, setData);
                if (dataWeb.code == 0) {
                    setUser(dataWeb.user);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }
    const handleRequestLicenceUpdate = async () => {
        if (idUser > 0) {
            try {
                setLoading(true)
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/user/profile/update',
                        'JWT': getCookie("JWT"),
                        //  
                    },
                    body: JSON.stringify({ jsonLicencesUpdated: "" }),
                    //mode: 'no-cors'  // Bypasses CORS but limits the response
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }
                const dataWeb = await response.json();
                addNotificationStatus(data, setData);
                if (dataWeb.code == 0) {
                    setUpdate(false);
                    setUser(dataWeb.user);
                }
            } catch (error: any) {
                addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
            } finally {
                setLoading(false)
            }
        };
    }

    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <SpaceBetween direction='horizontal' size='xs'>
                            <FormField label="Últ actualización"
                                constraintText={
                                    !!user && user.jsonLicencesUpdated !== "" && (
                                        <Link onClick={() => setUpdate(true)} variant="info">Solicitar actualización</Link>)}>

                                {user?.jsonLicencesUpdated === "" ? "Sin info" : user?.jsonLicencesUpdated}
                            </FormField>
                            <Favorites />
                        </SpaceBetween>
                    }>Mis licencias</Header>

                    <SpaceBetween direction='vertical' size='xs'>


                        {user?.jsonLicences && user?.jsonLicences?.length === 0 ?

                            <Box textAlign="center" margin={{ vertical: "xxxl" }}>
                                <b><Icon path={mdiInformation} size={1} /> No hay licencias sincronizadas con la DGAC para este usuario.</b>
                            </Box>
                            : <Licences licences={user?.jsonLicences || []} />
                        }
                    </SpaceBetween>

                    {!!update && handleRequestLicenceUpdate && (
                        <Confirm type="info" show={update} action={'Solicitar'} warning={'Al solicitar la actualización de sus licencias, se ingresará su solicitud. Esta solicitud puede tardar hasta 24 horas en ejecutarse'} header='Solicitud'
                            onDismiss={() => setUpdate(false)}
                            onConfirm={() => {
                                handleRequestLicenceUpdate();
                            }}
                        />
                    )}
                </SpaceBetween>
            }
        />
    )
};
